import ServiceReport from "../../Services/ServiceReport";
import {
	ISummaryPort,
	SummaryProducer,
	IError,
	Producer,
	ShipmentSummary,
	createStages,
} from "../../Models/Report";
import { ActionsReport } from "./Types";
import { getColorCompany } from "../../Models/Colors";
import Modal from "antd/lib/modal";

const service = new ServiceReport();

let requestPending: any = undefined;

export const createActionRequest = () => ({
	type: ActionsReport.REQUEST_REPORT_DASHBOARD,
});

export const createActionSetProducers = (producers: Producer[]) => ({
	type: ActionsReport.SET_PRODUCERS,
	payload: producers,
});

export const createActionFetchStageData = (
	producer: Producer,
	summary: SummaryProducer
) => {
	return (dispatch: any) => {
		producer.stages.map(async (s) => {
			const res = new SummaryProducer();
			res.idProducer = producer.id;
			res.report = s.report;
			const data = summary.status.find((st) => st.name === s.alias);
			res.total = data ? data.total : 0;
			dispatch({
				type: ActionsReport.SET_STAGES,
				payload: res,
			});
		});
	};
};

export const createActionFetchPort = (id: number) => {
	return (dispatch: any) => {
		service
			.fetchPort(id)
			.then(async (r) => {
				const data: ISummaryPort[] | IError[] = await r.json();
				let summaries: SummaryProducer[] | undefined;
				if ("Status" in data[0]) {
					summaries = [];
				} else {
					summaries = SummaryProducer.transform(data as ISummaryPort[]);
				}
				const producers: Producer[] = [];
				for (let i = 0; i < summaries.length; i += 1) {
					const summary = summaries[i];
					const producer = new Producer();
					producer.id = summary.idProducer;
					producer.name = summary.nameProducer;
					producer.branchs = summary.branchs;
					producer.summary = summary;
					producer.color = getColorCompany(producers.length);
					producer.stages = createStages();
					producer.loading = false;
					producers.push(producer);
				}
				dispatch(createActionSetProducers(producers));
				producers.map((p) =>
					dispatch(createActionFetchStageData(p, p.summary))
				);
			})
			.catch((r) => {
				// TODO: default result failed
			});
	};
};

export enum EReport {
	Announced,
	Summary,
	Stacking,
	Consolidate,
	BreakBulk,
	Bath,
	Yard,
}

export const createActionRequestAnounced = () => ({
	type: ActionsReport.REQUEST_ANNOUNCED,
});

export const createActionReportData = (
	fetch: Promise<Response>,
	idProducer: string
) => {
	return (dispatch: any) => {
		const dispatchError = () => {
			service.resetSignal();
			dispatch({
				type: ActionsReport.FETCH_ANNOUNCED_LOAD,
				payload: [],
			});
			dispatch(createActionRequestAnounced());
		};
		dispatch(createActionRequestAnounced());
		const timeout = setTimeout(() => {
			service.cancelSignal();
			Modal.error({ title: "Problema de Comunicación", content: "La consulta de datos está tomando mucho tiempo, por lo cual fue cancelada" })
		}, 60000);
		fetch
			.then(async (r) => {
				clearTimeout(timeout);
				service.resetSignal();
				const data = await r.json();
				const res = SummaryProducer.transform(data);
				res.forEach((e) => {
					e.idProducer = idProducer;
				});
				dispatch({
					type: ActionsReport.FETCH_ANNOUNCED_LOAD,
					payload: res,
				});
				dispatch(createActionRequestAnounced());
			})
			.catch((e) => {
				clearTimeout(timeout);
				dispatchError();
			});
	};
};

export const createActionFetchSummary = (
	id: number,
	idProducer: string,
	idBranch: number
) => {
	return (dispatch: any) => {
		dispatch(createActionsRequestShipment);
		service
			.fetchSummary(id, idProducer, idBranch)
			.then(async (r) => {
				dispatch(createActionsRequestShipment);
				const data = await r.json();
				const res = ShipmentSummary.create(data);
				dispatch({
					type: ActionsReport.FETCH_SHIPMENT,
					payload: res,
				});
			})
			.catch((e) => {
				dispatch(createActionsRequestShipment);
			});
	};
};

export const createActionClearData = (report: EReport) => {
	return (dispatch: any) => {
		switch (report) {
			case EReport.Announced:
				dispatch({
					type: ActionsReport.FETCH_ANNOUNCED_LOAD,
					payload: undefined,
				});
				break;
			case EReport.Summary:
				dispatch({
					type: ActionsReport.FETCH_SHIPMENT,
					payload: undefined,
				});
				break;
		}
	};
};

export const createActionsRequestShipment = {
	type: ActionsReport.REQUEST_SHIPMENT,
};

export const createActionSetBranch = (
	id: number,
	idProducer: string,
	idBranch: number
) => {
	return (dispatch: any) => {
		dispatch(createActionClearData(EReport.Summary));
	};
};

export const createActionSetProducer = (
	id: number,
	idProducer: string,
	report: EReport
) => {
	return (dispatch: any) => {
		switch (report) {
			case EReport.Announced:
				return dispatch(
					createActionReportData(
						service.fetchAnnounced(id, idProducer),
						idProducer
					)
				);
			case EReport.Stacking:
				return dispatch(
					createActionReportData(
						service.fetchStacking(id, idProducer),
						idProducer
					)
				);
			case EReport.Consolidate:
				return dispatch(
					createActionReportData(
						service.fetchConsolidate(id, idProducer),
						idProducer
					)
				);
			case EReport.BreakBulk:
				return dispatch(
					createActionReportData(
						service.fetchBreakBulk(id, idProducer),
						idProducer
					)
				);
			case EReport.Yard:
				return dispatch(
					createActionReportData(service.fetchYard(id, idProducer), idProducer)
				);
			case EReport.Bath:
				return dispatch(
					createActionReportData(service.fetchBath(id, idProducer), idProducer)
				);
			case EReport.Summary:
		}
	};
};
